import { FC } from 'react';
import { Button } from '@mui/material';

interface TabButtonProps {
    isActive: boolean;
    text: string;
    onClick: () => void;
}

export const TabButton: FC<TabButtonProps> = ({ isActive, text, onClick }) => {
    return isActive ? (
        <Button disableElevation className="text-sky-700 hover:text-sky-800 bg-sky-100 hover:bg-sky-200" variant="text" onClick={onClick}>
            {text}
        </Button>
    ) : (
        <Button disableElevation className="text-slate-500 hover:text-sky-600 hover:bg-sky-50" variant="text" onClick={onClick}>
            {text}
        </Button>
    );
};
